import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'
import { useTranslation } from 'react-i18next'
import { Floor } from 'zens-store'

import { InfoTable } from '../info'

const styles = StyleSheet.create({
  container: {},
})

interface Props extends ViewProps {
  floor: Floor
  locationId: number
}
const FloorInfo = (props: Props) => {
  const { floor, locationId, style, ...otherProps } = props

  const { companyId, buildingId, name, number } = floor
  const { t } = useTranslation()
  const config = {
    fields: [
      {
        label: t('Floor level'),
        value: `${number}`,
      },
      {
        label: t('Floor name'),
        value: name,
      },
    ],
  }
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <InfoTable
        title={t('Floor details')}
        companyId={companyId}
        config={config}
        buttonHref={`/companies/${companyId}/locations/${locationId}/buildings/${buildingId}/floors/${floor.id}`}
      />
    </View>
  )
}

export default FloorInfo
